import React from "react";

import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import Dropdown from "rc-dropdown";
import "rc-dropdown/assets/index.css";
import Menu, { Item as MenuItem } from "rc-menu";
import { MenuInfo } from "rc-menu/lib/interface";

export interface Action {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
}

interface ActionDropdownProps {
  actions: Action[];
  onSelect: (info: MenuInfo) => void;
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({
  actions,
  onSelect,
}) => {
  const menu = (
    <Menu
      onClick={onSelect}
      className="text-sm"
      selectable={false}
      style={{ minWidth: 140, borderRadius: 4 }}
    >
      {actions.map((action) => (
        <MenuItem
          key={action.key}
          className="hover:bg-gray-100 hover:text-primary flex items-center gap-2"
          style={{ padding: "8px 10px", cursor: "pointer" }}
        >
          {action.icon && <span className="text-primary">{action.icon}</span>}
          <span>{action.label}</span>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="ml-1 flex gap-2 items-center justify-center w-full hover:bg-primary/10 rounded"
      >
        <EllipsisHorizontalIcon className="size-5 text-primary" />
      </div>
    </Dropdown>
  );
};

export default ActionDropdown;
